<template>
  <div class="table-settings !mr-[-12px]">
    <!-- <RedoSetting v-if="getSetting.redo" :getPopupContainer="getTableContainer" />
    <SizeSetting v-if="getSetting.size" :getPopupContainer="getTableContainer" />
    <FullScreenSetting
      v-if="getSetting.fullScreen"
      :appMode="getSetting.fullScreen === 'APP'"
      :getPopupContainer="getTableContainer"
    /> -->
    <ColumnSetting
      v-if="getSetting.setting"
      :key="table?.getBindValues?.value.tableId"
      :getPopupContainer="getTableContainer"
      :cache="getSetting.settingCache"
      @columns-change="handleColumnChange"
    />
  </div>
</template>
<script lang="ts" setup>
  import { computed, unref } from 'vue';
  import type { PropType } from 'vue';
  import { useTableContext } from '../../hooks/useTableContext';
  import type { ColumnChangeParam, TableSetting } from '../../types/table';
  import ColumnSetting from './ColumnSetting.vue';
  // import FullScreenSetting from './FullScreenSetting.vue';
  // import RedoSetting from './RedoSetting.vue';
  // import SizeSetting from './SizeSetting.vue';

  defineOptions({ name: 'TableSetting' });

  const props = defineProps({
    setting: {
      type: Object as PropType<TableSetting>,
      default: () => ({}),
    },
  });

  const emit = defineEmits(['columns-change']);

  const table = useTableContext();

  const getSetting = computed((): TableSetting => {
    return {
      redo: true,
      size: false,
      setting: true,
      settingCache: false,
      fullScreen: 'APP',
      ...props.setting,
    };
  });

  function handleColumnChange(data: ColumnChangeParam[]) {
    emit('columns-change', data);
  }

  function getTableContainer() {
    return table ? unref(table.wrapRef) : document.body;
  }
</script>
<style lang="less">
  .table-settings {
    display: flex;

    & > * {
      margin-right: 12px;
    }

    svg {
      width: 1.3em;
      height: 1.3em;
    }
  }
</style>
